import { users } from "../../../fake-db/users";
import { MessageType } from "../../../types/messageType";
import Avatar from "../../common/Avatar";
import MessageAction from "./MessageAction";

interface props {
  isUser: boolean;
  data: MessageType;
}

const MessageText = ({ isUser, data }: props) => {
  const user = users.filter((item) => {
    return `${item.id}` === data.receiverId;
  });

  return (
    <div
      className={`flex gap-2 items-end group ${
        !isUser ? "justify-start" : "justify-end"
      }`}
    >
      {!isUser && <Avatar isSmall data={users[0]} activeStatus={false} />}
      <div
        className={`${
          isUser
            ? "bg-white text-slate-500 shadow-sm"
            : "bg-violet-500 text-white"
        } sm:p-2 md:p-[10px] sm:px-2 md:px-3 rounded-md text-sm relative max-w-[90%]`}
      >
        {data.message.text}
        <MessageAction isUser={isUser} data={data} />
      </div>
      <div className="relative">
        {isUser && !user[0].isActive && (
          <div className="h-[16px] w-[16px] rounded-full bg-slate-300 flex items-center justify-center">
            <i className="fa-solid fa-check text-white text-[10px]"></i>
          </div>
        )}
        {isUser && user[0].isActive && (
          <Avatar isSmall data={user[0]} activeStatus={false} />
        )}
      </div>
    </div>
  );
};

export default MessageText;
